<template>
<div>
	<Form :label-width="110">
		<Row :gutter="10">
			<Col span="8">
				<FormItem label="保单号">
					<Input v-model="params.policyNo" clearable @on-enter="search" placeholder="请输入保单号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="参保公司">
					<Input v-model="params.companyName" clearable @on-enter="search" placeholder="参保公司名称"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="保单状态">
					<Select v-model="params.policyStatus" placeholder="请选择保单状态" clearable >
						<Option value="UNDONE">未完成</Option>
						<Option value="CHEJIAN">撤件</Option>
						<Option value="CHENGBAOJIAN">承保</Option>
						<Option value="EXCEPTION">异常</Option>
						<Option value="JUBAO">拒保</Option>
					</Select>
				</FormItem>
			</Col>
		</Row>
		<Row :gutter="10">
			<Col span="8">
				<FormItem label="起保日期">
					<daterange @on-change="val=>{setDateRange(val,'effectiveDateStart')}" is-fulltime placeholder="请选择起保日期" ></daterange>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="终保日期">
					<daterange @on-change="val=>{setDateRange(val,'effectiveDateEnd')}" is-fulltime placeholder="请选择终保日期" ></daterange>
				</FormItem>
			</Col>
			<Col span="8" class="right">
				<Button type="info" @click="search">搜索</Button>
				<Button type="primary" @click="excel">导出</Button>
			</Col>
		</Row>
	</Form>
	<p class="totalM">
		保费合计：{{total}}元 
	</p>
	<i-table :columns="columns" url="/trainee/queryPolicy" :params="params" ref="table" >
		<template slot-scope="{ row, index }" slot="action">
			<a @click="toDetail(row)">查看详情</a>
		</template>
	</i-table>
</div>
</template>

<script>
import ITable from '@/components/common/ITable'
import daterange from '@/components/common/daterange'

export default {
	components:{daterange,ITable},
	data () {
		return {
			params:{},
			columns:[
				{title: '参保公司',key: 'companyName',minWidth:200,fixed: 'left'},
				{title: '联系人',key: 'userName',minWidth:120},
				{title: '参保人数',key: 'insuredCount',minWidth:120,align:'right'},
				{title: '保费（元）',key: 'premium',width:120,align:'right'},
				{title: '保单号',key: 'policyNo',width:240},
				{title: '保单状态',key: 'policyStatusName',width:130},
				{title: '起保日期',key: 'effectiveDateStart',width:180},
				{title: '终保日期',key: 'effectiveDateEnd',width:180},
				// {title: '产品名称',key: 'productName',width:160},
				{title: '保险公司',key: 'insuranceCompanyName',minWidth:330},
				// {title: '保障状态',key: 'insuranceStatusName',width:130},
				// {title: '结算状态',key: 'endBillStatusName',width:100},
				// {title: '操作人',key: 'userName',width:100},
				{title: '生成时间',key: 'createTime',width:180},
				// {title: '备注',key: 'remarks',width:360},
				{title: '操作',slot: 'action',width:100,fixed: 'right'},
			],
			total:''
		}
	},
	created () {
		this.getTotal();
	},
	methods: {
		// 获取总计
		getTotal(){
			this.$axios.post("/trainee/queryPolicyPremium",this.params).then(res=>{
				this.total=res||''
			})
		},
		search () {
			this.$refs.table.getList();
			this.getTotal();
		},
		excel () {
			this.exportToExcel("/trainee/exportPolicy",this.params);
		},
		setDateRange (val,key) {
			this.params[key+"Begin"] = val[0];
			this.params[key+"End"] = val[1];
		},
		toDetail(row){
			window.open('/haierProduct.html#/trainee-employer/policy-detail/'+row.syncId)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/traineeEmployer/list/Policy.vue